export default "__VITE_ASSET__tkGR3Rdr__"